import React, { useEffect, useState } from 'react'
import ClientWrapper from '../ClientWrapper'
import ClientNavItem from './ClientNavItem'
import { HomeOutlined, LocalShippingOutlined, DiscountOutlined, RequestQuoteOutlined, SavingsOutlined, ReportProblemOutlined, InfoOutlined } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { NavItemsProps } from '../../Layout/NavItem'
import { ShoppingCartOutlined } from '@mui/icons-material'; // Carrito de compras
import { SessionState, isClient } from '../../../reducers/auth/session'
import { connect, useDispatch } from 'react-redux'
import { AppState } from '../../../reducers'
import { fetchPrepaymentCount } from '../../../actions/prepayment/prepaymentCount'
import ComplaintNavItem from './ComplaintNavItem'
import { fetchPendingPreorder } from '../../../actions/preorder/preorder'
import Preorder from '../../../models/Preorder'
import { PreorderDataState } from '../../../reducers/preorder/preorderData'
import { ReceiptLongOutlined } from '@mui/icons-material';
import { PinAngle } from 'react-bootstrap-icons'
import { Collapse } from '@mui/material'

interface Props {
  session?: SessionState
  preorder?: PreorderDataState
}

const ClientNavItems: React.FC<NavItemsProps & Props> = (props) => {
  const { t } = useTranslation("menu")
  const dispatch = useDispatch()
  const [prepaymentCount, setPrepaymentCount] = useState<number>(0)
  const [pendingPreorder, setPendingPreorder] = useState<number>(0)
  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  const getPendingPreorder = () => {
    if (props.session && isClient(props.session)) {
      dispatch(fetchPendingPreorder((preorder: Preorder) =>
        setPendingPreorder(preorder ? 1 : 0)))
    }
  }

  const getPrepaymentCount = () => {
    if (props.session && isClient(props.session)) {
      dispatch(fetchPrepaymentCount(props.session.byPersonTypeId ? props.session.byPersonTypeId?.toString() : '', (count: number) => setPrepaymentCount(count)))
    }
  }

  useEffect(() => {
    getPrepaymentCount()
    getPendingPreorder()
    // eslint-disable-next-line react-hooks/exhaustive-deps    
  }, [])

  useEffect(() => {
    getPendingPreorder()
    // eslint-disable-next-line react-hooks/exhaustive-deps    
  }, [props.preorder?.preorder?.id])


  return <ClientWrapper>
    <ClientNavItem
      uri='dashboard'
      title={t('home')}
      icon={<HomeOutlined />}
      {...props}
    />

    <ClientNavItem
      uri='accounts'
      title={t('account')}
      icon={<ReceiptLongOutlined />}
      {...props}
    />


    <ClientNavItem
      uri='currentAccounts'
      title={t('currentAccount')}
      icon='attach_money'
      {...props}
    />


    {prepaymentCount > 0 && <ClientNavItem
      uri='prepayments'
      title={t('prepayments')}
      icon={<SavingsOutlined />}
      {...props}
    />}

    <ClientNavItem
      uri='orders'
      title={t('orders')}
      icon={<LocalShippingOutlined />}
      {...props}
    />

    <ClientNavItem
      notification={pendingPreorder > 0 ? <PinAngle /> : null}
      notificationColor='error'
      //uri='preorders'
      uri={prepaymentCount > 0 ? 'preorders/prepayments' : pendingPreorder > 0 ? 'preorders/main' : 'preorders/deliveries'}
      title={t('newOrder')}
      icon={<ShoppingCartOutlined />}
      {...props}
    />

    <ComplaintNavItem
      base='client'
      uri='complaints'
      title={t('complaints')}
      icon={<ReportProblemOutlined />}
      {...props} />


    <ClientNavItem
      uri='downloads'
      title={t('downloadReport')}
      nested
      icon={<InfoOutlined />}
      onClick={handleClick}
      openItem={open}
      {...props}
    />

    <Collapse in={open} timeout="auto" style={{
      marginTop: open ? props.open ? "-16px" : "-6px" : "0px",
      marginBottom: open ? props.open ? "-16px" : "-6px" : "-16px"
    }}>
      <ClientNavItem
        uri='dlPriceList'
        title={t('priceList')}
        icon={<RequestQuoteOutlined />}
        subItem
        {...props}
      />
      <ClientNavItem
        uri='discountList'
        title={t('discountList')}
        icon={<DiscountOutlined />}
        subItem
        {...props}
      />

      {/*<ClientNavItem
        uri='people'
        title={t('people')}
        icon='contacts'
        subItem
        {...props}
      />*/}
    </Collapse>
  </ClientWrapper>
}


const mapStateToProps = (state: AppState) => ({
  session: state.session,
  preorder: state.preorderData
})

export default connect(mapStateToProps, null)(ClientNavItems)

